<template>
  <div class="title-con" :style="{ width: width }">
    <div class="title">{{ title }}</div>
    <div class="subtitle-con">
      <div class="sub-title">{{ subTitle }}</div>
      <div class="more" @click="showMoreWrapper">
        <div>查看</div>
        <div class="more-icon"></div>
      </div>
    </div>
    <div class="devide-line" :style="{ width: width }">
      <div class="inline"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    showMore: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "450px",
    },
    // showMoreWrapper: {
    //   type: Function,
    // },
  },
  methods: {
    showMoreWrapper() {
      this.$emit("showMore", "service");
    },
  },
};
</script>

<style lang="scss" scoped>
.title-con {
  height: auto;
  .title {
    font-weight: bold;
    font-family: "Microsoft Yahei", Arial, "sans-serif";
    font-size: 24px;
    writing-mode: horizontal-tb;
    letter-spacing: 0px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    overflow: unset;
    text-overflow: unset;
    white-space: unset;
    color: rgb(121, 218, 255);
    background-image: none;
    background-clip: unset;
    -webkit-text-fill-color: initial;
  }
  .subtitle-con {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .sub-title {
      color: rgb(133, 133, 133);
      font-weight: normal;
      font-family: arial, Arial, "sans-serif";
      font-size: 14px;
      writing-mode: horizontal-tb;
    }
    .more {
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgb(81, 218, 239);
      font-weight: normal;
      font-family: arial, Arial, "sans-serif";
      font-size: 16px;
      writing-mode: horizontal-tb;
      letter-spacing: 0px;
      cursor: pointer;
      .more-icon {
        width: 20px;
        height: 23px;
        pointer-events: auto;
        transform: rotate(270deg);
        image-rendering: -webkit-optimize-contrast;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url("../../assets/index/more.png");
        -webkit-mask-image: none;
        -webkit-mask-repeat: initial;
        -webkit-mask-size: initial;
        border-radius: 0px;
        cursor: pointer;
      }
    }
  }
  .devide-line {
    position: relative;
    width: 450px;
    height: 4px;
    transform: rotate(0deg);
    opacity: 1;
    pointer-events: none;
    background: rgb(87, 87, 87);
    filter: blur(0px);
    backdrop-filter: blur(0px);
    margin-top: 5px;
    margin-bottom: 5px;
    .inline {
      position: absolute;
      width: 150px;
      height: 4px;
      transform: rotate(0deg);
      opacity: 1;
      pointer-events: none;
      left: 1px;
      top: 1px;
      border-radius: 0px;
      background: rgba(70, 249, 249, 0.61);
      filter: blur(0px);
      backdrop-filter: blur(0px);
    }
  }
}
</style>
